import Debug from "debug";
const debug = Debug("upscope:cache");

const MINUTES_TO_EXPIRE_CACHE = 5;

export function fetchFromCache<R extends Record<string, any>>(cacheKey?: string): R | undefined {
  if (!cacheKey) return;

  const key = storageKey(cacheKey);

  const cache = sessionStorage.getItem(key);

  if (!cache) {
    debug("Cache not found, will fetch the visitor...");
    return;
  }

  debug("Visitor found in cache: %o", JSON.parse(cache));
  const parsedResponse = JSON.parse(cache) as R & { expiresAt: number };

  if (parsedResponse.expiresAt < new Date().getTime()) {
    debug("Cache expired, removing...");
    sessionStorage.removeItem(key);
    return;
  }

  return parsedResponse as R;
}

export function cacheVisitor<R extends Record<string, any>>(cacheKey: string, response: R) {
  sessionStorage.setItem(
    storageKey(cacheKey),
    JSON.stringify({ ...response, expiresAt: new Date().getTime() + MINUTES_TO_EXPIRE_CACHE * 60000 }),
  );
  debug("Visitor cached, will expire in 5 minutes: %o", response);
}

function storageKey(cacheKey: string): string {
  return `upscope:watchLinks:${cacheKey}`;
}
